<template>
	<div class="row">
		<div class="col-12 col-md-4 offset-md-4 mt-5">
			<login/>
		</div>
	</div>
</template>

<script>
import Login from '../Widgets/Login/Login.vue';


export default {
  name: 'Home',
  components: {
    Login,
  },
	created() {
		if(this.$cookies.isKey('token')){
			this.$router.push({ name: 'contratos' });
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
